import * as React from 'react';
import {Box, Paper, ToggleButton, ToggleButtonGroup, Typography} from '@mui/material';

// A chart with its title, what it shows, and a way to see the same numbers as a table (for screen readers, for copying, and
// for anyone who wants the exact values). Without a `table` (the card is one already) there is nothing to switch to.
export function ChartCard({title, subtitle, table, children}: { title: string, subtitle?: string, table?: React.ReactNode, children: React.ReactNode }) {
    const [view, setView] = React.useState<'chart' | 'table'>('chart');
    const headingId = React.useId();

    return (
        <Paper variant="outlined" component="section" aria-labelledby={headingId} sx={{p: {xs: 2, sm: 3}, minWidth: 0, borderRadius: 2}}>
            <Box sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5, mb: 3}}>
                <Box sx={{minWidth: 0, flex: '1 1 180px'}}>
                    <Typography id={headingId} variant="h6" component="h2">{title}</Typography>
                    {subtitle && <Typography variant="body2" color="text.secondary" sx={{mt: 0.5, maxWidth: 520}}>{subtitle}</Typography>}
                </Box>
                {table && <ToggleButtonGroup size="small" exclusive value={view} onChange={(_, next) => next && setView(next)} aria-label={`${title}: chart or table`}>
                    <ToggleButton value="chart" aria-label="Show as a chart">Chart</ToggleButton>
                    <ToggleButton value="table" aria-label="Show as a table">Table</ToggleButton>
                </ToggleButtonGroup>}
            </Box>
            {view === 'chart' || !table ? children : table}
        </Paper>
    );
}
